<template>
  <div
    class="tag"
    :class="`tag-${type}`"
  >
    <slot />
  </div>
</template>

<script>
export default {
  name: 'tag',
  props: {
    type: {
      type: String,
      default: '',
    },
  },
};
</script>

<style scoped lang="scss">
.tag {
  display: inline;
  margin: 5px;
  padding: 8px 10px;
  font-size: 12px;
  font-weight: bold;
  border-radius: 15px;

  &-feature {
    color: #3cbf68;
    background-color: #caf0da;
  }

  &-location,
  &-poi {
    color: #6e7c91;
    background-color: #ebf0f6;
  }

  &-amenity {
    color: #e48616;
    background-color: #ffedc1;
  }

  &-rating {
    color: #6558fe;
    background-color: #e2e4ff;
  }
}
</style>
